import { useListUsersQuery } from 'generated/graphql';
import { useMemo } from 'react';
import { mapListUsersItems } from 'v2/core/repository/edge-server/listUsers/mapListUsersItems';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { EdgeResponse } from 'v2/core/repository/edge-server/types';
import {
  ListUsersItem,
  UseListUsersInput,
  UseListUsersResponse,
} from 'v2/core/repository/edge-server/types/listUsers';

export const useListUsers = (
  input: UseListUsersInput,
  onCompleted?: (users: ListUsersItem[]) => void,
): EdgeResponse<UseListUsersResponse> => {
  const { data, loading, error, called } = useListUsersQuery({
    variables: input,
    onCompleted: (data) => onCompleted?.(mapListUsersItems(data)),
    fetchPolicy: 'cache-and-network',
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  const respData = useMemo((): UseListUsersResponse | undefined => {
    if (!data?.listUsers) {
      return;
    }
    return {
      users: mapListUsersItems(data),
    };
  }, [data]);

  return {
    data: respData,
    error,
    status,
  };
};
